document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("newsletter-form");
    if (!form) return;

    const formId = form.dataset.formId;
    const emailInput = document.getElementById("newsletter-email");
    const consentInput = document.getElementById("newsletter-data-consent");
    const message = document.getElementById("newsletter-form-message");

    function showMessage(text, isError) {
        message.textContent = text;
        message.classList.remove("hidden");
        message.classList.toggle("bg-red-700", isError);
        message.classList.toggle("bg-green-700", !isError);
    }

    function hideMessage() {
        message.textContent = "";
        message.classList.add("hidden");
    }

    form.addEventListener("submit", async (event) => {
        event.preventDefault();
        hideMessage();

        const submitButton = form.querySelector("button[type='submit']");
        submitButton.disabled = true;

        try {
            const response = await fetch(`/umbraco/forms/delivery/api/v1/entries/${formId}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    values: {
                        email: emailInput.value,
                        dataConsent: consentInput.checked ? "on" : "",
                    },
                }),
            });

            if (response.status === 202) {
                const result = await response.json();
                showMessage(result.messageOnSubmit || "Thank you for subscribing!", false);
                form.reset();
                return;
            }

            if (response.status === 422) {
                const problem = await response.json();
                const firstError = Object.values(problem.errors ?? {})[0]?.[0];
                showMessage(firstError || "Please check your details and try again.", true);
                return;
            }

            showMessage("Something went wrong. Please try again later.", true);
        } catch (err) {
            console.error("Newsletter form submission failed:", err);
            showMessage("Something went wrong. Please try again later.", true);
        } finally {
            submitButton.disabled = false;
        }
    });
});
